<template>
  <div class="modal fade" tabindex="1" role="dialog" id="contentModalForm">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content" v-if="item.title" :id="`content-${item.id}`">
        <div class="modal-header">
          <h5 class="modal-title truncated" v-if="item.uuid">Edit "{{ item.title[defaultLanguage.code] }}"</h5>
          <h5 class="modal-title" v-else>Aggiungi Card</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="close()">
            <i class="fal fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
            <div class="switch-languages">
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item" v-for="(language, index) in languages">
                  <a class="nav-link" :class="{'active' : activeLanguageIndex === index}" :id="`${language.code}-tab`" data-toggle="tab" :href="`#${language.code}`" role="tab" :aria-controls="language.code" aria-selected="true">{{ language.label }}</a>
                </li>
              </ul>
              <!--<a href="" class="btn btn-white">Modifica lingue</a>-->
            </div>

            <div class="tab-content clearfix">
              <div class="tab-pane" :class="{'active' : activeLanguageIndex === index}" id="1a" v-for="(language, index) in languages" :id="language.code">
                <div class="row">
                    <div class="col-md-10">
                        <div class="form-group">
                            <label>Titolo <span v-if="defaultLanguage.id === language.id">(obbligatorio)</span></label>
                            <input type="text" required class="form-control" :placeholder="item.title[defaultLanguage.code]" v-model="item.title[language.code]">
                            <span v-if="titleError"><small style="color:red; font-size: 12px;">{{ titleError }}</small></span>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label>Prezzo</label>
                            <input type="text" required class="form-control" v-model="item.price" placeholder="€">
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label>Descrizione</label>
                    <textarea name="" class="form-control content-description paragraphed" :id="`content-description-${item.id}-${language.code}`"
                    v-model="item.description[language.code]" :data-lang-code="language.code" :placeholder="item.description[defaultLanguage.code]"  rows="5"></textarea>
                </div>
               <!--  <div class="form-group">
                    <label>Tag</label>
                    <select class="form-control" multiple="true" :data-language-id="language.id">
                      <option :value="tag.id" v-for="tag in tags" v-if="tag.language_id == language.id" :selected="shouldDataBeSelected(tag.id)">{{ tag.name }}</option>
                    </select>
                </div> -->
                <div class="form-group last-form-group">
                    <label>Link esterno</label>
                    <input type="text" class="form-control" :disabled="item.children.length > 0" :placeholder="item.external_url[defaultLanguage.code]"  v-model="item.external_url[language.code]">
                    <span v-if="urlError"><small style="color:red; font-size: 12px;">{{ urlError }}</small></span>
                    <p class="text-muted">Se inserisci un link esterno non puoi aggiungere una card di secondo livello.</p>
                </div>
              </div>
            </div>
            <template v-if="canShowBusinessModelForm()">
                <div class="tab-content clearfix">
                    <div class="form-group business-model-section">
                        <div class="tab-pane">
                            <div class="form-group last-form-group">
                                <label>Business Model</label>
                                <div class="form-check" v-for="businessModel in businessModels">
                                    <input type="radio" class="form-check-input" v-bind:id="'businessModel_' + businessModel.key" name="item.restaurant.businessModel" v-bind:value="businessModel.key" v-model="restaurantBusinessModel" />
                                    <label class="form-check-label" v-bind:for="'businessModel_' + businessModel.key">
                                        {{ businessModel.name }}&nbsp;&nbsp;<span class="text-muted">{{ businessModel.description }}</span>
                                    </label>
                                </div>
                                <span v-if="businessModelValidationError"><small style="color:red; font-size: 12px;">{{ businessModelValidationError }}</small></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="canOverrideChargesFee()" class="tab-content clearfix pt-0">
                    <div class="row">
                        <div class="form-group business-model-section mb-0 col-8">
                            <div class="tab-pane">
                                <div class="form-group last-form-group">
                                    <div class="form-check form-check-inline mt-2">
                                        <input type="radio" class="form-check-input" v-bind:id="'businessModelFee_free'" name="item.restaurant.businessModelFeeType" value="free" v-model="restaurantBusinessModelFeeType" :disabled="!canSelectBusinessModelFees()" />
                                        <label class="form-check-label mb-0" :class="{'text-muted': !canSelectBusinessModelFees()}" v-bind:for="'businessModelFee_free'">
                                            Free&nbsp;
                                        </label>
                                    </div>
                                    <div class="form-check form-check-inline mt-2">
                                        <input type="radio" class="form-check-input" v-bind:id="'businessModelFee_service_fee'" name="item.restaurant.businessModelFeeType" value="service_fee" v-model="restaurantBusinessModelFeeType" :disabled="!canSelectBusinessModelFees()" />
                                        <label class="form-check-label mb-0" :class="{'text-muted': !canSelectBusinessModelFees()}" v-bind:for="'businessModelFee_service_fee'">
                                            Service Fee (€)&nbsp;
                                        </label>
                                    </div>
                                    <div class="form-check form-check-inline mt-2">
                                        <input type="radio" class="form-check-input" v-bind:id="'businessModelFee_percentage'" name="item.restaurant.businessModelFeeType" value="percentage" v-model="restaurantBusinessModelFeeType" :disabled="!canSelectBusinessModelFees()" />
                                        <label class="form-check-label mb-0" :class="{'text-muted': !canSelectBusinessModelFees()}" v-bind:for="'businessModelFee_percentage'">
                                            Percentuale (%)&nbsp;
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group business-model-section mb-0 col-4">
                            <div class="tab-pane">
                                <div class="form-group last-form-group">
                                    <input type="text" :class="{'text-muted': !canSelectBusinessModelFees()}" name="item.restaurant.businessModelFeeValue" v-model="restaurantBusinessModelFeeValue" placeholder="Inserisci valore" :disabled="!canSelectBusinessModelFees()" />
                                </div>
                                <span v-if="businessModelFeeValueValidationError"><small style="color:red; font-size: 12px;">{{ businessModelFeeValueValidationError }}</small></span>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <div class="tab-content clearfix">
                <div class="form-group upload-section">
                    <div class="tab-pane">
                        <div class="form-group last-form-group">
                            <label>Immagini <span v-if="item.media">({{item.media.length}})</span></label>
                            <!-- <p>Altezza e larghezza massima 1024. Peso massimo 2MB</p> -->
                            <template v-if="Object.keys(mediaUploadErrors).length">
                            <p v-for="error in mediaUploadErrors" style="color:red"><small>{{ error[0] }}</small></p>
                            </template>
                            <div class="uploader">
                              <ActivityMediaGallery :activityUuid="activityUuid" :item="item" v-on:updated="handleMediaUpdateForItem($event, item)"/>
                              <ActivityPhotoUploader
                                :activityUuid="activityUuid"
                                :itemUuid="item.uuid"
                                v-on:uploaded="handleMediaUpdateForItem($event, item)"
                                v-on:uploaderror="handleMediaErrorForItem($event, item)"
                                v-on:resetuploaderror="mediaUploadErrors = {}"
                                v-on:added="handleMediaReadyForItem($event, item)"
                                ></ActivityPhotoUploader>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
          <a type="button" class="btn btn-danger" href="#" @click.prevent="attemptDeleteItem()">Elimina</a>
          <div>
              <button type="button" class="btn btn-white" data-dismiss="modal" id="modal-close" @click.prevent="close()">Annulla</button>
              <button type="button" class="btn" @click.prevent="save()">Salva</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import EventBus from './EventBus'
  import ActivityPhotoUploader from './ActivityPhotoUploader'
  import ActivityMediaGallery from './ActivityMediaGallery'
  export default {
    name: 'ActivityItemModal',

    components: {
      ActivityPhotoUploader,
      ActivityMediaGallery
    },

    data () {
        return {
            itemIsEmpty: true,
            titleError: null,
            urlError: null,
            businessModelValidationError: null,
            businessModelFeeValueValidationError: null,
            activeLanguageIndex: 0,
            mediaUploadErrors: {},
            item: {},
            restaurantBusinessModel: 'paper',
            restaurantBusinessModelFeeType: 'free',
            restaurantBusinessModelFeeValue: null,
        }
    },
    props: ['languages', 'defaultLanguage', 'activityUuid', 'tags', 'businessModels'],

    watch: {
      restaurantBusinessModel: function(newValue, oldValue) {
        if (newValue == 'paper') {
            this.restaurantBusinessModelFeeType = 'free';
            this.restaurantBusinessModelFeeValue = 0;
        }
        this.item.restaurant.business_model = this.restaurantBusinessModel;
        this.item.restaurant.fee_type = this.restaurantBusinessModelFeeType;
        this.item.restaurant.fee_value = this.restaurantBusinessModelFeeValue * 100;
      },
      restaurantBusinessModelFeeType: function(newValue, oldValue) {
        if (newValue == 'free') {
            this.restaurantBusinessModelFeeValue = 0;
        }
        this.item.restaurant.fee_type = this.restaurantBusinessModelFeeType;
      },
      restaurantBusinessModelFeeValue: function(newValue, oldValue) {
        this.item.restaurant.fee_value = this.restaurantBusinessModelFeeValue * 100;
      }
    },

    methods: {
      shouldDataBeSelected (tag_id) {
        return this.item.uuid && Object.values(this.item.tags).map((tag) => tag.id).includes(parseInt(tag_id))
      },

      attemptDeleteItem () {
          this.$swal({
            title: 'Are you sure you want to delete this item?',
            text: 'This data cannot be restored.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete!',
            cancelButtonText: 'Do not delete.'
          }).then((result) => {
              if (result.value) {
                  this.delete()
              }
          })
      },

      delete () {
        window.axios.delete(`/activities/${this.activityUuid}/${this.item.uuid}`, {}).then((response) => {
            this.close()
            EventBus.$emit('newContentAdded')
        })
      },

      handleMediaUpdateForItem (event, item) {
        this.item.media = event.media
      },

      handleMediaReadyForItem (event, item) {
        if(!this.item.uploads) {
          this.item.uploads = []
        }
        if(!this.item.uploads.filter(file => file.name === event.detail.file.file.name).length){
          this.item.uploads.push(event.detail.file.file)
        }
      },

      handleMediaErrorForItem (event, item) {
        this.mediaUploadErrors = event.errors
      },

      close() {
        this.activeLanguageIndex = 0
        this.$emit('close')
        this.destroyEditors()
        this.resetEmptyItem()
        $('#modal-close').trigger('click')
      },

      destroyEditors() {
        $('#content-' + this.item.id).find('.content-description').each(function(){
          console.log('did it')
          $('#' + $(this).attr('id')).trumbowyg('destroy');;
        })
      },

      save () {
        console.log('onSave')
        this.titleError = null
        this.urlError = null
        this.businessModelValidationError = null
        this.businessModelFeeValueValidationError = null
        //check title on primary
        let hasPrimaryTitle = this.item.title[this.defaultLanguage.code].length > 0
        let hasAnyUrls = Object.values(this.item.external_url).filter((url) => url != null && url.length > 0).length > 0
        let hasPrimaryLanguageUrl = this.item.external_url[this.defaultLanguage.code] && (this.item.external_url[this.defaultLanguage.code].length > 0)
        let hasBusinessModel = this.canShowBusinessModelForm() ? !_.isEmpty(this.restaurantBusinessModel) : true;
        let hasBusinessModelFeeValue = (this.canShowBusinessModelForm() && this.restaurantBusinessModel != 'paper' && this.restaurantBusinessModelFeeType != 'free' && (this.restaurantBusinessModelFeeValue == '' || typeof(this.restaurantBusinessModelFeeValue) == undefined)) ? false : true;

        let titleValidationFails = !hasPrimaryTitle
        let urlValidationFails = hasAnyUrls && !hasPrimaryLanguageUrl
        let businessModelValidationFails = !hasBusinessModel
        //let businessModelFeeValidationFails = !hasBusinessModelFeeValue
        let businessModelFeeValidationFails = false

        if(titleValidationFails) {
          this.titleError = "Il titolo per la lingua principale è obbligatorio."
        }

        if(urlValidationFails) {
          this.urlError = "L'url esterno per il linguaggio primario è obbligatorio in questo caso."
        }

        if(businessModelValidationFails) {
          this.businessModelValidationError = "Il business model è obblitagorio."
        }

        if(businessModelFeeValidationFails) {
          this.businessModelFeeValueValidationError = "Il valore del fee è obbligatorio in questo caso."
        }

        if(titleValidationFails || urlValidationFails || businessModelValidationFails || businessModelFeeValidationFails) {
          return false;
        }

        var form_data = new FormData();
        Object.keys(this.item).forEach(key => {
          if(typeof this.item[key] === 'object') {
            if (key !== 'parent_item') {
                form_data.append(key, JSON.stringify(this.item[key]))
            } else {
                let parentItem = _.omit(this.item[key], ['children']);
                form_data.append(key, JSON.stringify(parentItem));
            }
          } else {
            form_data.append(key, this.item[key])
          }
        });

        if(this.item.uploads) {
          let files = this.item.uploads
          var ins = files.length
          for (var x = 0; x < ins; x++) {
            form_data.append("uploads[]", files[x]);
          }
        }

        window.axios.post(`/activities/${this.activityUuid}/content`, form_data, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then((response) => {
          this.close()
          EventBus.$emit('newContentAdded')
          if(!this.item.uuid) {
            this.$toasted.show('Content added successfully', { icon: 'info' })
          } else {
            this.$toasted.show('Content updated successfully', { icon: 'info' })
          }
        }).catch(e => {
          if(e.response.status === 422) {
            this.mediaUploadErrors = e.response.data.errors
          }
        })
      },

      doEditor (id) {
        let _this = this
        $('#content-' + id).find('.content-description').each(function(){
          $('#' + $(this).attr('id')).trumbowyg({
              btns: [['strong', 'em', 'underline',],],
              autogrow: false,
              removeformatPasted: true
          }).on('tbwchange', function(e, two){
            _this.item.description[$(e.target).data('lang-code')] = e.target.value
          });
        })
      },

      doSelect2 () {
        let _this = this
        $('select').select2({
          tags: true
        }).on("select2:select", function(event) {
          setTimeout(() => _this.mapTags(event.currentTarget), 50)
        }).on("select2:unselect", function(event) {
          setTimeout(() => _this.mapTags(event.currentTarget), 50)
        })
      },

      mapTags(target) {
        var added = {};
        var _this = this

        var language_id = $(target).data('language-id')

        $(target).find("option:selected").each(function(i, selected){
          let val = $(selected).val()
          let text = $(selected).text()
          if(val !== text) {
            if(!_this.shouldDataBeSelected(val)) {
              _this.item.tags.push(_this.tags.filter((tag) => tag.id == val)[0])
            }
          } else {
            added[val] = text;
          }
        });

        $(target).find("option:not(:selected)").each(function(i, not_selected){
          let val = $(not_selected).val()
          let text = $(not_selected).text()
          _this.item.tags = _this.item.tags.filter((tag) => {
            if(tag.language_id != language_id) {
              return true
            }
            return tag.id != val
          })
        });

        if(!this.item.new_tags) {
          this.item.new_tags = {}
        }
        this.item.new_tags[language_id] = added
      },

      resetEmptyItem () {
        let localItem = {
                uuid: null,
                active: false,
                title: {},
                description: {},
                external_url: {},
                price: null,
                images:  [],
                tags: [],
                children: [],
            }

        this.languages.forEach((lang) => {
          localItem.title[lang.code] = ''
          localItem.description[lang.code] = ''
          localItem.external_url[lang.code] = ''
        });

        this.item = localItem
      },

      canShowBusinessModelForm() {
        return (this.item.restaurant);
      },

      canSelectBusinessModelFees() {
        return (this.restaurantBusinessModel !== '' && this.restaurantBusinessModel !== 'paper');
      },

      canOverrideChargesFee() {
        //return !(this.restaurantBusinessModel == '' || this.restaurantBusinessModel == 'paper');
        return false;
      }
    },

    mounted () {
        this.resetEmptyItem()
        let _this = this
        EventBus.$on('setCurrentEditableItem', (payload) => {
          if (payload) {
            if(Object.keys(payload).length === 1) {
              this.item.parent_id = payload.parent_id;
            } else {
              this.item = payload;
            }
            if (this.canShowBusinessModelForm()) {
              this.restaurantBusinessModel = ((this.item.restaurant.business_model != '') ? this.item.restaurant.business_model : 'paper');
              this.restaurantBusinessModelFeeType = ((this.item.restaurant.fee_type != '') ? this.item.restaurant.fee_type : 'free');
              this.restaurantBusinessModelFeeValue = ((this.item.restaurant.fee_value != '') ? (this.item.restaurant.fee_value / 100) : null);
            }
          }
          $('#contentModalForm').modal('show')

          $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            _this.doSelect2()
          })

          setTimeout(() => {
            _this.doSelect2()
            _this.doEditor(_this.item.id)
          }, 200)
        })

        $('.modal').on('hidden.bs.modal', function () {
            _this.destroyEditors()
        });
    }
  };
</script>
<style scoped>
  .uploader::-webkit-scrollbar {
    display: none;
  }

  .truncated {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
